import {Bars} from 'react-loader-spinner'
import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import Chart from '../../Chart/Chart';
import {authContext} from '../../Context/Authentication/authContext';
import {baseURL, dataScienceURL} from '../../config';
import {generateChartData} from '../../Helpers/helpers'

const MonthsOfSupply = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);

  useEffect(() => {
    if (state.filters.showInterval && state.filters.city?.length === 1) {
      getMonthsOfSupplyByInterval();
    }
    else{
      getMonthsOfSupplyByCounty();

    }
   
  }, [state.filters.years, state.filters.city,state.filters.value,state.filters.showInterval]);

  const generateIntervalChartData = (apiData: any) => {
    try {
      const data: any = apiData.map((item: any) => {
        return {
          date: item?.date,
          value1: item?.mos_high,
          value2: item?.mos_low,
          value3: item?.mos,
        };
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getMonthsOfSupplyByInterval=async ()=>{
    const city = JSON.stringify(state.filters.city)
    .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
    .replaceAll('"', "'");
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const response = await axios.get(
        `${baseURL}getMonthsOfSupplyInterval?state=${
          state.filters.state
        }&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  }

  const getMonthsOfSupplyByCounty = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const county = JSON.stringify(state.filters.county)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${dataScienceURL}getMosCounty?state=${state.filters.state}&county=${county}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const resp = response.data?.cube
      const data = generateChartData(resp, 'mos');
      setChartData(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className='population-main'>
      {chartData === null ? (
        <div className='daysOnMarket-main__chartContainer__isLoading'>
          <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
        </div>
      ) : chartData?.length ? (
        <>
          <div className='population-main__text'>Months Of Supply</div>
          <Chart
            chartData={chartData}
            title={'Months Of Supply'}
            city={state.filters.city}
            county={state.filters.county}
            showInterval={state.filters.showInterval}
            zipcode={state.filters.zipcode}
          />
        </>
      ) : (
        <div className='daysOnMarket-main__chartContainer__noData'>
          No Data Available
        </div>
      )}
    </div>
  );
};

export default React.memo(MonthsOfSupply);
